import { render, staticRenderFns } from "./ServidorNew.vue?vue&type=template&id=2a74e16b&scoped=true&"
import script from "./ServidorNew.vue?vue&type=script&lang=js&"
export * from "./ServidorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74e16b",
  null
  
)

export default component.exports